import { useCurrentUser } from '@/hooks/useCurrentUser';
import { useEffect, useState } from 'react';
import { alert } from '@/services/alert';
import { getReferenceString } from '@medplum/core';
import { PractitionerRole } from '@medplum/fhirtypes';

export default function useDefaultPractitioner(
  practitionerRoles: PractitionerRole[],
  setSelectedProvider: (provider: string[]) => void
) {
  const {
    currentUserPermissions: { isAdmin, hasAdminMembership },
    currentUser,
  } = useCurrentUser();
  const [isDefaultPractitionerSelected, setIsDefaultPractitionerSelected] = useState(false);

  useEffect(() => {
    if (isAdmin || hasAdminMembership) {
      setIsDefaultPractitionerSelected(true);
      return;
    }
    if (!currentUser || practitionerRoles.length === 0) return;

    const practitionerRole = practitionerRoles.find(
      (r) => r.practitioner?.reference === getReferenceString(currentUser)
    );
    if (!practitionerRole) {
      alert.warning('No practitioner role found for current user');
      setIsDefaultPractitionerSelected(true);
      return;
    }

    const practitionerRef = getReferenceString(practitionerRole);
    if (!practitionerRef) {
      alert.warning('No practitioner reference found for current user');
      setIsDefaultPractitionerSelected(true);
      return;
    }

    setSelectedProvider([practitionerRef]);
    setIsDefaultPractitionerSelected(true);
  }, [isAdmin, hasAdminMembership, currentUser, practitionerRoles]);

  return {
    isDefaultPractitionerSelected,
  };
}
